module.exports = "https://www.digikey.com/product-detail/en/LTST-C150CKT/160-1167-1-ND/269239\n\nC = Q/V\nQ= It\nC = It/V\nV=IR\n\nC= t/R\n"